import { AttrField, BelongsToField, HasManyByField, OrmModel, StringField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'
import AttachmentFile from '@/data/models/domain/attachmentFile/AttachmentFile'
import UserPersonalInfo from '@/data/models/domain/UserPersonalInfo'

@OrmModel(modelNames.NOTE)
export default class Note extends BaseModel {
  @StringField()
  public id: string

  @StringField(null)
  public note: string

  @StringField()
  public userId: string

  @BelongsToField(UserPersonalInfo, 'userId')
  public user: UserPersonalInfo

  @StringField()
  public createdAt: string

  @AttrField([])
  public attachmentFileIds: string[]

  @HasManyByField(AttachmentFile, 'attachmentFileIds')
  public files: AttachmentFile[]
}
